import { render, staticRenderFns } from "./CampaignSetupsListContent.vue?vue&type=template&id=74a33d34"
import script from "./CampaignSetupsListContent.vue?vue&type=script&lang=js"
export * from "./CampaignSetupsListContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports